import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { getSubscriber } from '../selectors'
import { redirect, home, createCall, handleError } from '../actions'
import { localizations } from '../config'
import FormWizard, { FormWizardItem } from '../components/FormWizard'
import DestinationSelection from './DestinationSelection'

import '../styles/connect-view'

const SubscriberProperty = ({ subscriber, property, label }) => {
    let value = subscriber != null ? subscriber[property] : ''
    let labelText = localizations[property] || property
    return (
        <div className="row">
            <div className="col-sm-4"><strong>{labelText || property}: </strong></div>
            <div className="col-sm-8">{(property === 'ip' && value != '') ? <a href={'http://' + value} target='_new'>{value}</a> : value || '-'}</div>
        </div>
    )
}

const SubscriberInfo = ({ subscriber }) => (
    <div>
        <SubscriberProperty {...{ subscriber }} property="username" />
        <SubscriberProperty {...{ subscriber }} property="name" />
        <SubscriberProperty {...{ subscriber }} property="description" />
        <SubscriberProperty {...{ subscriber }} property="device" />
        <SubscriberProperty {...{ subscriber }} property="site_name" />
        <SubscriberProperty {...{ subscriber }} property="unit" />
        <SubscriberProperty {...{ subscriber }} property="ip" />
    </div>
)

const InfoPanel = ({ title, children }) => (
    <div className="panel panel-primary">
        <div className="panel-heading">
            <div className="panel-title">{title}</div>
        </div>
        <div className="panel-body">
            {children}
        </div>
    </div>
)

class ConnectView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            profile: props.profile || props.profiles[0],
            message: props.message
        }
        this.initiateCall = this.initiateCall.bind(this)
    }
    selectCallee(callee) {
        const { push, profiles, location } = this.props
        push(Object.assign(location, { query: { to: callee.username || callee } }))
        // for phone numbers select last profile
        if (typeof callee === 'string') {
            this.setState({ profile: profiles[profiles.length - 1] })
        }
    }

    jumpToStep(step) {
        const { home, push, location } = this.props
        switch (step) {
            case 1: home(); break;
            case 2: push(location.pathname); break;
            case 3: this.setState({ profile: null }); break;
        }
    }

    initiateCall() {
        const { caller, callee, createCall, redirect, handleError } = this.props
        const { profile, message } = this.state
        createCall(caller, callee, profile.value, message).then(() => redirect('/calls')).catch(handleError)
    }

    render() {
        const { caller, callee, subscribers, home, createCall } = this.props
        const { profile, message = '' } = this.state
        const profiles = callee && callee.phoneNumber ? [this.props.profiles.find(p => p.key === 13)] : this.props.profiles.slice(0, this.state.showAdvancedProfiles ? this.props.profiles.length : 4)
        return (
            <div className="connect-view">
                <h1>Connect</h1>
                <FormWizard onStepClick={step => this.jumpToStep(step)}>
                    <FormWizardItem complete={true} title="Step 1" description="Select source" />
                    <FormWizardItem complete={callee} title="Step 2" description="Select destination" />
                    <FormWizardItem complete={callee && profile} title="Step 3" description="Select profile" />
                    <FormWizardItem title="Step 4" description="Connect" />
                </FormWizard>
                {caller &&
                    <div className="steps">
                        <div>
                            <InfoPanel title="Source">
                                <SubscriberInfo subscriber={caller} />
                            </InfoPanel>
                        </div>
                        {!callee ?
                            <DestinationSelection {...{ caller }} onSelect={c => this.selectCallee(c)} />
                            :
                            <div>
                                <InfoPanel title="Destination">
                                    {callee.phoneNumber ? callee.phoneNumber : <SubscriberInfo subscriber={callee} />}
                                </InfoPanel>
                            </div>
                        }
                        {callee &&
                            <div>
                                <div className="form-group">
                                    {
                                        profiles.map(p => (
                                            <div className="radio" key={p.key}>
                                                <label>
                                                    <input type="radio" name="profile" checked={!!profile && profile.key === p.key} value={p.key} onChange={e => this.setState({ profile: p })} />
                                                    {p.name} {p.description && '(' + p.description + ')'}
                                                </label>
                                            </div>
                                        ))}
                                    {callee.username && !this.state.showAdvancedProfiles &&
                                        <div>
                                            <a href="#" onClick={e => { e.preventDefault(); this.setState({ showAdvancedProfiles: true }) }}>more...</a>
                                        </div>
                                    }
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="Connection description" value={message} onChange={(e) => this.setState({ message: e.target.value })} />
                                </div>
                                {profile &&
                                    <p className="pull-right">
                                        <button className="btn btn-default" onClick={this.initiateCall}>Connect</button>
                                    </p>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, { caller, params, location }) => {
    const { to, profile, message } = location.query
    const props = {
        profiles: state.config.profiles,
        message
    }
    if (!caller) {
        props.caller = getSubscriber(state, params.subscriberId)
    }
    if (to) {
        props.callee = getSubscriber(state, to) || { phoneNumber: to }
    }
    if (profile) {
        props.profile = props.profiles.find(p => p.key == profile || p.value == profile)
    }
    return props
}

export default connect(mapStateToProps, { home, createCall, push, redirect, handleError })(ConnectView) 


// WEBPACK FOOTER //
// ./containers/ConnectView.jsx